
import React, { useMemo } from 'react';
import { CheckOutlined, CloseOutlined, InfoOutlined, LockOutlined, NextPlanOutlined, UploadFileOutlined } from "@mui/icons-material";
import { Drawer } from "@mui/material";
import colors from "../../../../scss/colors";
import CVUploader from "../../../../Components/common/CVUploader/CVUploader";
import MainButton from "../../../../Components/common/buttons/MainButton";
import { buttonVariants } from "../../../../Components/common/buttons/types";
import ProfileCard from '../ProfileCard/ProfileCard';
import CircularProgress from '../../../../Components/common/CircularProgress/CircularProgress';
import { calculateProfileCompletion } from '../../../../utils/helpers';

export default function ProfileStrength({ strength, customClass, total }) {
    return (
        <ProfileCard customClass={`${customClass} md:gap-6 sticky top-0`}>
            <div className='flex flex-row justify-center items-start w-full'>
                <h4 className='!text-base sm:!text-xl !font-medium text-center'>Profile Strength</h4>
            </div>
            <div className='flex flex-row justify-center items-center items-start w-full text-sm md:text-base mb-4'>
                <CircularProgress percentage={total} />
            </div>
            <div className="flex flex-col justify-center w-full">
                {(strength ?? []).map((profile, index) => (
                    <div className='flex flex-row gap-3 cursor-pointer last:border-none border-gray-200 border-b pb-4 pt-4' role='presentation' onClick={profile?.action}>
                        <span>
                            {profile?.isSectionComplete ? 
                                <CheckOutlined className='text-green-600' />
                                :
                                <CloseOutlined className='text-gray-500' />
                            }
                        </span>
                        <span>{profile?.label}</span>
                        {!profile?.isSectionComplete && (
                            <span className={`font-medium ${profile?.isSectionComplete ? 'text-gray-500' : 'text-green-600'}`}>{profile?.percentage}%</span>
                        )}
                    </div>
                ))}
            </div>
        </ProfileCard>
    );
}
